import UploadFiles from './uploadfiles'

export default UploadFiles